<template>
  <div>
    <div v-if="loading || !formLoaded">
      <span class="spinner"></span>
    </div>
    <div v-if="!loading && formLoaded">
      <b-form
        @submit.stop.prevent="onSubmit"
        :class="{
          'p-3 box-shadow2 rounded': !isDarkMode,
          'dark-div p-3 box-shadow2 rounded': isDarkMode
        }"
      >
        <b-form-group id="group-name" label-for="input-name">
          <template v-slot:label>
            Task Name
            <span class="text-danger">*</span>
          </template>

          <b-form-input
            class="box-shadow2"
            id="input-name"
            type="text"
            v-model="form.taskName"
            placeholder="Enter Task Name"
            :state="$v.form.taskName.$dirty ? !$v.form.taskName.$error : null"
          ></b-form-input>

          <b-form-invalid-feedback id="input-title-invalid">Please enter task name.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="group-description" label-for="input-description">
          <template v-slot:label>
            Description
            <span class="text-danger">*</span>
          </template>

          <b-form-input
            id="input-description"
            type="text"
            v-model="form.taskDescription"
            placeholder="Enter Task Description"
            :state="$v.form.taskDescription.$dirty ? !$v.form.taskDescription.$error : null"
          ></b-form-input>

          <b-form-invalid-feedback id="input-name-invalid">Please enter task description.</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="group-product" label-for="input-product">
          <template v-slot:label>
            Active
            <span class="text-danger">*</span>
          </template>

          <multiselect
            id="input-status"
            placeholder="Select Active Type"
            v-model="form.active"
            :options="['True', 'False']"
            :state="$v.form.active.$dirty ? !$v.form.active.$error : null"
          ></multiselect>
        </b-form-group>

        <b-form-group id="group-product" label-for="input-product">
          <template v-slot:label> Date </template>
          <div class="calender">
            <b-form-datepicker
              id="datepicker"
              placeholder="Select Date"
              :min="minDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              v-model="form.date"
              class="ml-2 mb-2"
            ></b-form-datepicker>
          </div>
        </b-form-group>

        <b-form-group id="group-product" label-for="input-product">
          <template v-slot:label>
            Communication Type
            <span class="text-danger">*</span>
          </template>

          <multiselect
            id="input-type"
            placeholder="Select Communication Type"
            v-model="form.communicationType"
            :options="['Morning Communication', 'Evening Communication', 'Special Communication']"
          ></multiselect>
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            Region Ids
            <span class="text-danger"></span>
          </template>

          <multiselect
            ref="multiselect"
            tag-placeholder="Add this as new tag"
            track-by="value"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            v-model="regionids"
            placeholder="Select region Ids"
            label="text"
            :options="regions"
          >
          </multiselect>
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            Cluster Ids
            <span class="text-danger"></span>
          </template>
          <multiselect
            ref="multiselect"
            tag-placeholder="Add this as new tag"
            track-by="value"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            v-model="clusterids"
            placeholder="Select Cluster Ids"
            label="text"
            :options="clusters"
          >
          </multiselect>
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            Store Ids
            <span class="text-danger"></span>
          </template>
          <multiselect
            v-model="storeids"
            ref="multiselect"
            tag-placeholder="Add this as new tag"
            placeholder="Select Store Ids"
            label="text"
            track-by="value"
            :options="stores"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          ></multiselect>
          <b-form-text id="input-role-help"
            >Note: The first selected store id will be the primary store id.</b-form-text
          >
          <b-button @click="uploadStores" variant="success">Upload Stores</b-button>
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            Role
            <span class="text-danger">*</span>
          </template>

          <multiselect
            id="input-role"
            v-model="form.role"
            placeholder="Select role"
            label="text"
            ref="multiselect"
            track-by="value"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :options="role"
          ></multiselect>
        </b-form-group>

        <b-form-group id="group-products" label-for="input-products">
          <template v-slot:label>
            Upload File
            <span class="text-danger">*</span>
          </template>
          <input type="file" @change="uploadFile($event)" />
          <!-- <input multiple type="file" @change="uploadFile($event)" /> -->
        </b-form-group>
        <div v-if="this.formType === 'new'">
          <li v-for="item in this.form.attachments" :key="item.id">
            {{ item.name }}
            <b-button @click="removeFile(item)" variant="danger">
              <font-awesome-icon :icon="['fas', 'trash']" class="mr-10" />
            </b-button>
          </li>
        </div>
        <div v-if="this.formType === 'update'">
          <li v-for="item in this.form.attachments" :key="item.id">
            <a :href="item" target="_blank">{{ item }}</a>
            <b-button @click="removeFile(item)" variant="danger">
              <font-awesome-icon :icon="['fas', 'trash']" class="mr-10" />
            </b-button>
          </li>
        </div>

        <div class="input wrapper items-center" v-for="(input, email) in inputs" :key="email">
          <b-row class="mb-3">
            <b-col>
              <b-row>
                <b-col cols="4">
                  <template labelfor="input-category"> Email </template>
                  <b-form-input
                    id="input-email"
                    v-model="input.email"
                    placeholder="Enter Email Address"
                    type="email"
                    aria-describedby="input-live-help input-live-feedback"
                    value="ok"
                  ></b-form-input>
                </b-col>

                <b-col sm="0">
                  <b-button
                    class="mt-4"
                    @click="remove(email)"
                    v-show="email || (!email && inputs.length > 1)"
                    variant="danger"
                    >Delete</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-button @click="add(email)" v-show="email == inputs.length - 1" variant="primary">Add</b-button>
        </div>
        <div class="upload">
          <b-button variant="success" @click="showUpload">Upload Emails</b-button>
        </div>

        <!-- <video class="videoPlayer" id="video-preview" controls v-show="file != ''" /> -->

        <template v-if="storeIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ storeIdError }}</b-col>
          </b-row>
        </template>
        <template v-if="regionIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ regionIdError }}</b-col>
          </b-row>
        </template>
        <template v-if="clusterIdError">
          <b-row class="mb-2">
            <b-col class="text-danger message-col">{{ clusterIdError }}</b-col>
          </b-row>
        </template>

        <b-form-group>
          <b-row class="mt-2">
            <b-col class="text-right">
              <b-button type="submit" size="sm" variant="success" :disabled="loading">
                <span class="spinner spinner-white" v-if="loading"></span>
                <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />Save
              </b-button>
              <b-button class="ml-2" size="sm" variant="warning" :to="{ path: `/cstTask` }">
                <font-awesome-icon :icon="['fas', 'long-arrow-alt-left']" class="mr-1" />Back to list
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import csv from 'csvtojson';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import configService from '@/services/configService';
import router from '@/router';
import Multiselect from 'vue-multiselect';

export default {
  name: 'CSTFormBox',
  components: {
    Multiselect
  },
  props: {
    listUrl: String,
    formType: String,
    taskType: String
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  data() {
    return {
      inputs: [
        {
          email: ''
        }
      ],
      taskName: '',
      taskDescription: '',
      file: [],
      formLoaded: true,
      email: '',
      regions: [],
      clusters: [],
      stores: [],
      storeids: [],
      clusterids: [],
      regionids: [],
      role: [],
      form: {
        taskName: '',
        taskDescription: '',
        active: 'True',
        date: null,
        storeids: [],
        regionids: [],
        attachments: [],
        clusterids: [],
        role: [],
        email: [],
        communicationMode: ''
      },
      storeIdError: null,
      clusterIdError: null,
      regionIdError: null,
      dateTimeFormat: configService.get('format').pickerDateTime,
      minDate: moment().format('YYYY-MM-DD')
    };
  },
  validations() {
    const formValidation = {
      taskDescription: {
        required
      },
      active: {
        required
      },
      taskName: {
        required
      }
    };

    if (this.formType === 'new') {
      formValidation.taskDescription.required = required;
      formValidation.taskName.required = required;
      formValidation.active.required = required;
    }

    return { form: formValidation };
  },
  mounted() {
    this.listRole({ router });
    this.listStore({ router });
    this.listCluster({ router, query: { type: 'cluster' } });
    this.listRegion({ router, query: { type: 'region' } });

    this.$nextTick(async () => {
      if (this.formType === 'new') {
        this.formLoaded = true;
        this.$v.$touch(); // Set initial validation
        this.$v.$reset(); // Reset $dirty
      }
    });
  },
  computed: {
    metaDescription() {
      return this.formType === 'new' ? 'Add new Task' : 'Update Task';
    },
    ...mapGetters('alert', ['errorMessages']),
    ...mapState('role', ['roles']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('cst', ['loading', 'task']),
    ...mapState('store', ['storeList', 'regionList', 'clusterList'])
  },
  methods: {
    ...mapActions('role', ['listRole']),
    ...mapActions('cst', ['listTask', 'getOne', 'postOne', 'patchOne', 'uploadTask']),
    ...mapActions('store', ['listStore', 'listRegion', 'listCluster']),

    // fileOnChange() {
    //   let files = this.$refs.attachments.files;

    //   if (!files.length) {
    //     return false;
    //   }

    //   for (let i = 0; i < files.length; i++) {
    //     this.form.attachments.push(files[i]);
    //   }
    //   this.uploadTask({ file: this.form.attachments });
    // },

    uploadFile(event) {
      this.file = event.target.files[0];
      this.uploadTask({ file: this.file });
      for (let i = 0; i < event.target.files.length; i++) {
        this.form.attachments.push(event.target.files[i]);
      }
    },

    removeFile(item) {
      if (this.form.attachments.includes(item)) {
        this.form.attachments.splice(this.form.attachments.indexOf(item), 1);
      }
    },
    createCsvEmail() {
      const csv = `Email\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleFile.csv';
      anchor.click();
    },

    async showUpload() {
      await Vue.swal({
        title: 'Upload file for emails..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your email file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsvEmail();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow.slice(1, csvRow.length).map(item => {
                  if (item[0].includes('@')) {
                    return { email: item[0] };
                  } else {
                    Vue.swal({
                      title: 'Invalid email',
                      text: `${item[0]} is not a valid email`,
                      icon: 'error',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                  }
                });
                this.inputs = inputs;
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },
    createCsv() {
      const csv = `Store Id\n`;
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'sampleFile.csv';
      anchor.click();
    },
    async uploadStores() {
      await Vue.swal({
        title: 'Upload file for Stores..',
        input: 'file',
        inputAttributes: {
          'aria-label': 'Upload your Store file in csv format'
        },
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Upload',
        denyButtonText: 'Download Sample',
        denyButtonColor: '#3a4',
        showCancelButton: true,
        showDenyButton: true,
        cancelButtonText: 'Close',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      }).then(result => {
        if (result.isDenied) {
          this.createCsv();
        }
        if (result.value) {
          const reader = new FileReader();
          reader.onload = async () => {
            csv({
              noheader: true,
              output: 'csv'
            })
              .fromString(reader.result)
              .then(csvRow => {
                const inputs = csvRow.slice(1, csvRow.length).map(item => {
                  if (item[0].length !== 4) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store Id ${item[0].charAt(0).toUpperCase() + item[0].slice(1)} must be 4 digits`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  const inUppercase = item[0].toUpperCase();
                  const compareStoreIdFromDatabse = this.newStoreList.filter(store => store.storeid === inUppercase);
                  if (compareStoreIdFromDatabse.length === 0) {
                    Vue.swal({
                      title: 'Access Denied',
                      text: `Store id ${
                        item[0].charAt(0).toUpperCase() + item[0].slice(1)
                      } is not found in database! Please enter correct store id.`,
                      type: 'error',
                      confirmButtonText: 'Ok',
                      background: this.isDarkMode ? '#464d54' : '#ffffff',
                      customClass: {
                        title: this.isDarkMode ? 'text-light' : 'text-dark',
                        content: this.isDarkMode ? 'text-light' : 'text-dark'
                      }
                    });
                    return null;
                  }
                  return {
                    value: item[0].charAt(0).toUpperCase() + item[0].slice(1),
                    text: item[0].charAt(0).toUpperCase() + item[0].slice(1)
                  };
                });
                const uniqueStoreId = new Set(inputs.map(input => input.value));
                const getDuplicateValue = [...uniqueStoreId].filter(
                  item => inputs.filter(input => input.value === item).length > 1
                );
                if (getDuplicateValue.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${getDuplicateValue[0]} is duplicate in sample file!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.abc = inputs.map(store => ({
                  value: store.value,
                  text: store.value
                }));
                const newAddingStore = this.abc.map(store => store.value);
                const foundExistStore = this.storeids.filter(store => newAddingStore.includes(store.value));
                if (foundExistStore.length > 0) {
                  Vue.swal({
                    title: 'Access Denied',
                    text: `Store id ${foundExistStore[0].value} is already there!`,
                    type: 'error',
                    confirmButtonText: 'Ok',
                    background: this.isDarkMode ? '#464d54' : '#ffffff',
                    customClass: {
                      title: this.isDarkMode ? 'text-light' : 'text-dark',
                      content: this.isDarkMode ? 'text-light' : 'text-dark'
                    }
                  });
                  return null;
                }
                this.storeids = [...this.storeids, ...this.abc];
              });
          };
          reader.readAsBinaryString(result.value);
        }
      });
    },

    onSubmit() {
      this.storeIdError = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (this.formType === 'new') {
        const storeids = [];
        this.storeids.map(({ value }) => storeids.push(value));

        const regions = [];
        this.regionids.map(({ value }) => regions.push(value));

        const clusters = [];
        this.clusterids.map(({ value }) => clusters.push(value));

        const roles = [];
        this.form.role.map(({ value }) => roles.push(value));

        const attachmentsName = [];
        this.form.attachments.map(({ name }) => attachmentsName.push(name));

        const task = {
          taskName: this.form.taskName,
          taskDescription: this.form.taskDescription,
          active: this.form.active === 'True',
          date: this.form.date,
          communicationMode: this.form.communicationMode,
          storeids,
          clusters: clusters || [],
          regions: regions || [],
          roles: roles || [],
          attachmentsName: attachmentsName || [],
          email: this.inputs.map(input => input.email)
        };
        this.$emit('add', { task });
      }
      if (this.formType === 'update') {
        const storeids = [];
        this.storeids.map(({ value }) => storeids.push(value));

        const regions = [];
        this.regionids.map(({ value }) => regions.push(value));

        const clusters = [];
        this.clusterids.map(({ value }) => clusters.push(value));

        const roles = [];
        const foundRoles = this.task.roles.map(({ value }) => value);
        this.form.role.map(({ value }) => {
          if (foundRoles.includes(value)) {
            roles.push(value);
          }
        });
        this.form.role.map(({ value }) => roles.push(value));

        const foundAttachments = this.task.attachments.map(i => i);

        const task = {
          taskName: this.form.taskName,
          taskDescription: this.form.taskDescription,
          active: this.form.active === 'True',
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          storeids,
          clusters: clusters || [],
          regions: regions || [],
          roles: roles || [],
          attachments: foundAttachments || [],
          email: this.inputs.map(input => input.email)
        };
        this.$emit('edit', { task });
      }
      return false;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
      setTimeout(() => {
        this.$refs.multiselect.$refs.search.focus();
      }, 100);
    },
    add() {
      this.inputs.push({ email: '' });
    },
    remove(index) {
      this.inputs.splice(index, 1);
    }
  },
  watch: {
    task(newValue) {
      if (!this.task.id) {
        return;
      }
      // Loaded Video Deatils, assign to form
      this.form.taskName = newValue.taskName;
      this.form.taskDescription = newValue.taskDescription;
      this.form.active = newValue.active;
      this.form.date = moment(newValue.date).format('YYYY-MM-DD');
      this.communicationMode = newValue.communicationMode;
      this.storeids = newValue.storeids.map(store => ({ value: store, text: store }));
      this.regionids = newValue.regions.map(region => ({ value: region, text: region }));
      this.clusterids = newValue.clusters.map(cluster => ({ text: cluster, value: cluster }));
      this.form.attachments = newValue.attachments.map(attachment => attachment);
      this.inputs = newValue.email.map(email => ({ email }));
      this.form.role = newValue.roles.map(({ name, _id }) => ({ text: name, value: _id }));

      this.formLoaded = true;
      this.$v.$touch(); // Set initial validation
      this.$v.$reset(); // Reset $dirty
    },
    clusterList(newValue) {
      this.clusters = newValue;
    },
    regionList(newValue) {
      this.regions = newValue;
    },
    roles(newValue) {
      this.role = newValue;
    },
    storeList(newValue) {
      let comparingStores = [];
      comparingStores = newValue.map(store => ({
        storeid: store.storeid
      }));
      this.newStoreList = comparingStores;
      this.stores = newValue.map(store => ({ text: store.storeid, value: store.storeid }));
    }
  }
};
</script>
<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.calender {
  display: flex;
  width: auto;
  margin-left: -9px;
  margin-bottom: 0.7rem;
}
.date {
  margin-left: -10px;
}
.upload {
  margin-top: 8px;
}
.videoPlayer {
  width: 25%;
}
.upload {
  margin-top: 8px;
}
</style>
